import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import API from "./axios/API";
import config from "./config";
import Loader from "./Layouts/Loader/Loader";
import APIDashboard from "./axios/APIDashboardHeader";

// Check access based on localStorage metadata
const checkAccess = (roleName, statusCode) => {
  // Check localStorage metadata for user access
  const userMetadata = JSON.parse(localStorage.getItem("metaData"));

  // Check if userMetadata exists and contains roles
  if (userMetadata && userMetadata.roles) {
    // Iterate over user's roles
    for (const role of userMetadata.roles) {
      // Check if roleName matches any role in userMetadata
      if (role.roleName === roleName && statusCode === 200) {
        console.log("Access Granted For Role:", roleName);
        return true; // User has access
      }
    }
  }

  return false; // User does not have access
};

// Higher-order component to wrap routes and check access
const ProtectedRoute = ({ element }) => {
  // Get roleName from localStorage
  const roleName = JSON.parse(localStorage.getItem("metaData"))?.roles[0]
    ?.roleName;

  const [statusCode, setStatusCode] = useState("");
  const [error, setError] = useState(null); // State to hold error
  const [loading, setLoading] = useState(true); // State to hold loading status

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await APIDashboard.post(
          config.baseUrl + "/adminservice/login/fetchUserDetails"
        );
        setStatusCode(response.status);
      } catch (error) {
        console.error("Error fetching Access Response:", error);
        setError(error); // Set error state
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchUserDetails();
  }, []); // Fetch details only when roleName changes

  // Check access once statusCode state is updated
  useEffect(() => {
    const hasAccess = checkAccess(roleName, statusCode);
    // If user has access, render the element, else redirect to unauthorized page
    if (!hasAccess) {
      <Navigate to={`${process.env.PUBLIC_URL}/`} />;
    }
  }, [statusCode, roleName]);

  // If there's an error, handle it
  if (error) {
    // Handle the "Not Found" error here, for example:
    console.error("API not found:", error);
    // Handle the error gracefully, e.g., redirect to an error page
    return <Navigate to={`${process.env.PUBLIC_URL}/`} />;
  }

  // Render loading indicator if still loading
  if (loading) {
    return <Loader/>;
  }

  // Render the element by default
  return element;
};

export default ProtectedRoute;
